import React, { useEffect, useState } from "react";
import './Button.css';

const baseURL = process.env.REACT_APP_API_URL;


const FetRepTable = ({ sortBy }) => {
    const [recipes, setRecipes] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchRecipes = async () => {
        try{
            setLoading(true);
            const res = await fetch(`${baseURL}/recipes`);
            const data = await res.json();
            setRecipes(data);
        } catch (err) {
            console.error('Failed to fetch recipes:', err);
        } finally {
            setLoading(false);
        }
        
    };

    useEffect(() => {
        fetchRecipes();
    }, []);

    const parseLikes = (likes) => {
        if(typeof likes === 'number') return likes;
        return parseInt(likes.replace(/,/g, ''), 10);
    }
    const parseDate = (date) => new Date(date);
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const sortedRecipes = [...recipes].sort((a, b) => {
        if(sortBy === "Likes") {
            return parseLikes(b.likes) - parseLikes(a.likes);
        }
        if(sortBy === "Dates") {
            return parseDate(b.createdAt) - parseDate(a.createdAt);
        }
        
        return 0;
    })

    const handleFeature = async (recipes) => {

        try{
            await fetch(`${baseURL}/recipes/${recipes._id}`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ isFeatured: !recipes.isFeatured })
            });

            fetchRecipes();

        } catch(err) {
            console.error('Failed to update featured status:', err);
        }
    };

    const handleRemove = async (index) => {
        const recipe = recipes[index];

        try{
            await fetch(`${baseURL}/recipes/${recipe._id}`, {
                method: 'DELETE'
            });
            
            const updatedRecipes = [...recipes];
            updatedRecipes.splice(index, 1);
            setRecipes(updatedRecipes);

        } catch(err) {
            console.error('failed to remove recipe:', err);
        }
    };

    if (loading) {
        return <div style={{ padding: '20px' }}>Loading recipes...</div>
    }

    return(
        <div className="recipe-table">
            <div className="table-header">
                <div className="col image-col">Recipes</div>
                <div className="col">Likes</div>
                <div className="col">Date</div>
                <div className="col action-col">Action</div>
            </div>
            {sortedRecipes.map((r, i) => (
                <div className={`table-row ${r.isFeatured ? 'featured-row' : ''}`} key={r._id}>
                  <div className="col image-col">
                    <img src={`${baseURL}/uploads/${r.image}`} alt={r.name} className="recipe-img" />
                  </div>
                  <div className="col">{r.likes}</div>
                  <div className="col">{formatDate(r.createdAt)}</div>
                  <div className="col action-col">
                    <div className="action-buttons">
                        <button className="feature-button" onClick={() => handleFeature(r)}>
                            {r.isFeatured ? 'Unfeature' : 'Feature'}
                        </button>
                        <button className="remove-button" onClick={() => handleRemove(i)}>Remove</button>
                    </div>
                  </div>
                </div>
            ))}
        </div>
    );
};
export default FetRepTable;